import styled from 'styled-components'

export const Wrapper = styled.div`
  padding-bottom: 24px;
  .rankmiTable-container {
    margin-top: -1px;
  }
  .rankmiTable-table {
    margin-top: -9px;
  }
`

export const HeaderActions = styled.div`
  button {
    border-radius: 8px;
    padding: 0 12px !important;
    height: 40px;
  }
  > button {
    svg {
      margin-right: 6px;
    }
  }
  div > button {
    color: #363636 !important;
    border-radius: 4px;
    width: 160px;
    border: 2px solid #d9d9d9 !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    svg {
      color: #757575;
    }
  }
  .dropdown-menu {
    border: none;
    border-radius: 8px;
    width: 200px;
    box-shadow: 0px 4px 16px 0px #00000029;
    a {
      color: #363636;
      padding: 4px 16px;
      transition: 200ms;
    }
    a:hover {
      background-color: #e7f3fe;
    }
    a.disabled {
      color: rgb(170, 169, 169);
    }
  }
  .ant-dropdown-menu {
    border-radius: 8px;
    width: 200px;
  }
  .ant-dropdown-menu-item {
    padding: 4px 16px;
  }
  .ant-dropdown-menu-item:hover {
    background-color: #e7f3fe;
  }
`
